import type { IAnalyticsPropContext } from '@inter-ikea-kompis/analytics';
import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import type { IDexfSettings } from '@inter-ikea-kompis/types';

import { IpexMomentEnum } from '@insights/insights-data-provider';

const moduleId = 'configuration_summary_confirmation_card';

/**
 * Tracks events from Configuration Summary Confirmation Card and sends them to a reporter.
 *
 * @event link_card_click When the link card is clicked.
 */
export default class ConfigurationSummaryConfirmationCardTracker extends AbstractAnalyticsTracker {
	private readonly context?: IAnalyticsPropContext['context'];

	constructor(options: {
		dev: boolean;
		ab?: boolean;
		settings: IDexfSettings;
		locale: string;
		reporterId?: string;
		context?: IAnalyticsPropContext['context'];
	}) {
		super({ moduleId, ...options });
		this.context = options.context;
	}

	/**
	 * Call to report when link card has been clicked.
	 *
	 * @param meta Optional metadata for the payload in the analytics event.
	 */
	public sendLinkCardClick(meta?: object): void {
		this.getReporter().report({
			event: 'link_card_click',
			ipexMoment: IpexMomentEnum.showMe,
			payload: { ...meta, context: this.context }
		});
	}
}
